
export default {
    name: 'SearchResults',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        searchResults: {
            type: null,
            default: null
        },
        page: {
            type: Number,
            default: 1
        },
        searchToken: {
            type: String,
            default: null
        }
    }
}
